import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';

/**
 * Search field for mobile menu sheets. Closes the sheet on submit
 * and routes to /search?q=... (or /search for browsing when empty).
 */
export default function MobileSearchField({ onSubmit }) {
  const navigate = useNavigate();
  const [q, setQ] = useState('');

  const submit = (e) => {
    e.preventDefault();
    const trimmed = q.trim();
    if (onSubmit) onSubmit();
    navigate(trimmed.length >= 2 ? `/search?q=${encodeURIComponent(trimmed)}` : '/search');
  };

  return (
    <form onSubmit={submit} className="px-4 pb-4 mb-2 border-b" data-testid="mobile-search-form" role="search">
      <p className="text-xs text-muted-foreground mb-2">Search</p>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search
            className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none"
            aria-hidden="true"
          />
          <Input
            type="search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Pets, people, posts…"
            className="pl-8 h-10"
            data-testid="mobile-search-input"
            aria-label="Search the site"
          />
        </div>
        <Button type="submit" size="sm" data-testid="mobile-search-submit">
          Go
        </Button>
      </div>
    </form>
  );
}
